<script setup lang="ts">
import pkg from '../../package.json'
import { ref } from 'vue'

const applicationVersion = ref(pkg.version)
</script>

<template>
  <div class="layout-footer">
    Creato da
    <a
      href="https://veicoliapp.com"
      target="_blank"
      rel="noopener noreferrer"
      class="text-primary font-bold hover:underline"
      >Veicoli Srl</a
    >
    <span class="font-small"> (v.{{ applicationVersion }}) </span>
  </div>
</template>
